module.exports = __webpack_public_path__ + "img/y_2021_2.57aa50e9.png";